import React, { useEffect, useState } from "react";

const useGetScreenSize = ()=>{
    const [tamañoPantalla, setTamañoPantalla] = useState({
        width: window.innerWidth,
        heigth: window.innerHeight
    })
     const cambioDeTamño = () => {
        setTamañoPantalla({
            width: window.innerWidth,
            heigth: window.innerHeight
        })
    }
    useEffect(() => {
        // Suscribirse al evento de cambio de tamaño
        window.addEventListener('resize', cambioDeTamño);

        // Función de limpieza para desuscribirse del evento
        return () => {
            window.removeEventListener('resize', cambioDeTamño);
        }
    }, [])
    return tamañoPantalla
    
}
export default useGetScreenSize